<template lang="pug">
div
    BreadCrumb(:linkBreadCrumb="linkBreadCrumb")
    CrudForm(
        v-bind="staticData"
        :fields="myFields"
        :customRules="customRules"
        @submitForm="handleSubmit($event)"
        :noButtons="!$can('CREATE_PRODUCT_SUBFAMILY')"
        )
    v-text-field 
</template>

<script>
/* components */
import { CrudForm, BreadCrumb } from '@/components/reusable_components'
import RUTInput from '@/components/RUTInput/RUTInput'
/* mixins */
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
/* services */
import SubfamilyService from '@/services/api/subfamily/SubfamilyService'
/* actions */
import { mapActions } from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {
            formData: {},
            form: null,
            fields: [
                {
                    field: 'subfamily',
                    type: 'text',
                    maxLength: 30,
                    value: '',
                    vuetifyProps: {
                        label: 'Nombre de Subfamilia',
                    },
                    rules: ['required'],
                },
            ],
            staticData: null,

            customRules: {
                minLength8: function(value) {
                    return value.length >= 8 ? true : 'El largo mínimo es 8'
                },
            },
            linkBreadCrumb: [
                {
                    text: 'Listado Familias',
                    disabled: false,
                    to: `/families`,
                    exact: true,
                },
                {
                    text: 'Familia',
                    disabled: false,
                    to: `/families/${this.$route.params.id}`,
                    exact: true,
                },
                {
                    text: 'Nueva Subfamilia',
                    disabled: true,
                },
            ],
        }
    },
    computed: {
        myFields() {
            return this.fields
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        async handleSubmit(event) {
            this.formData = event
            let snackInfo = this.fillSnack(
                'info',
                'Creando Subfamilia',
                'La subfamilia esta siendo Creada',
                true
            )
            //FIXME: fixed snack bar for allowing to throw different timeouts
            //this.initSnackbar(snackInfo)
            let response = await SubfamilyService.createSubfamily(
                this.$route.params.id,
                this.formData
            )
            if (response.status == 'success') {
                this.resetSnackbarState()
                let snackInfo = this.fillSnack(
                    'success',
                    'Éxito',
                    'La subfamilia fue creada exitosamente',
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
                this.$router.push({
                    path: `/families/${this.$route.params.id}`,
                })
            } else {
                //TODO:add snack
                console.log(event, 'error')
            }
        },
        fillStaticFormData() {
            let information = {}
            information.toolbarTitle = 'Nueva Subfamilia'
            information.toolbarIcon = 'close'
            information.customRules = function(value) {
                return value.length >= 8 ? true : 'El largo mínimo es 8'
            }
            information.editable = false
            information.disabled = false
            information.submitText = 'Crear Subfamilia'

            return information
        },
    },
    watch: {},
    components: { CrudForm, BreadCrumb },
    mixins: [InputValidations, CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    beforeMount: async function() {
        this.staticData = this.fillStaticFormData()
    },
    mounted: function() {
        this.setTitleTopBar('Nueva Subfamilia')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_PRODUCT_SUBFAMILY')) ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>